var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5C3.19023 2.5 3.75 3.05977 3.75 3.75C3.75 4.44141 3.19023 5 2.5 5C1.80977 5 1.25 4.44141 1.25 3.75C1.25 3.05977 1.80977 2.5 2.5 2.5ZM19.0625 2.8125C19.582 2.8125 20 3.23242 20 3.75C20 4.26953 19.582 4.6875 19.0625 4.6875H7.1875C6.66797 4.6875 6.25 4.26953 6.25 3.75C6.25 3.23242 6.66797 2.8125 7.1875 2.8125H19.0625ZM19.0625 9.0625C19.582 9.0625 20 9.48047 20 10C20 10.5195 19.582 10.9375 19.0625 10.9375H7.1875C6.66797 10.9375 6.25 10.5195 6.25 10C6.25 9.48047 6.66797 9.0625 7.1875 9.0625H19.0625ZM19.0625 15.3125C19.582 15.3125 20 15.7305 20 16.25C20 16.7695 19.582 17.1875 19.0625 17.1875H7.1875C6.66797 17.1875 6.25 16.7695 6.25 16.25C6.25 15.7305 6.66797 15.3125 7.1875 15.3125H19.0625ZM2.5 11.25C1.80977 11.25 1.25 10.6914 1.25 10C1.25 9.30859 1.80977 8.75 2.5 8.75C3.19023 8.75 3.75 9.30859 3.75 10C3.75 10.6914 3.19023 11.25 2.5 11.25ZM2.5 15C3.19023 15 3.75 15.5586 3.75 16.25C3.75 16.9414 3.19023 17.5 2.5 17.5C1.80977 17.5 1.25 16.9414 1.25 16.25C1.25 15.5586 1.80977 15 2.5 15Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.72a18d750d30a46e28b8aa6737b26b33.svg";
export { ForwardRef as ReactComponent };